import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _embedScriptByInstanceIdRequest = {};
var _embedScriptRequest = {};
var _embedScriptResponse = {};
var _getEmbeddedScriptByInstanceIdRequest = {};
var _getEmbeddedScriptRequest = {};
var _getEmbeddedScriptResponse = {};
function resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-instance-manager-webapp',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
            {
                srcPath: '/api/v1/instance',
                destPath: '/v1/instance',
            },
            {
                srcPath: '/api/v1/scripts',
                destPath: '/v1/scripts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Inserts custom script tags into a site.
 *
 *
 * Your app must have an existing
 * [embedded script component](https://dev.wix.com/docs/build-apps/developer-tools/extensions/embedded-scripts),
 * with exactly matching parameter names.
 */
export function embedScript(payload) {
    var _a = serializer(_embedScriptRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_embedScriptResponse, {}).fromJSON;
    function __embedScript(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
            method: 'POST',
            methodFqn: 'com.wixpress.market.aim.api.EmbeddedScriptsService.EmbedScript',
            url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
                protoPath: '/v1/scripts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __embedScript.fromReq = fromReq;
    __embedScript.__isAmbassador = true;
    return __embedScript;
}
/**
 * Retrieves information about your app's existing embedded script.
 *
 *
 * The call fails with `404` error in case your app doesn't include an
 * embedded script on the site.
 */
export function getEmbeddedScript(payload) {
    var _a = serializer(_getEmbeddedScriptRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEmbeddedScriptResponse, {}).fromJSON;
    function __getEmbeddedScript(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.EmbeddedScriptsService.GetEmbeddedScript',
            url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
                protoPath: '/v1/scripts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEmbeddedScript.fromReq = fromReq;
    __getEmbeddedScript.__isAmbassador = true;
    return __getEmbeddedScript;
}
export function embedScriptByInstanceId(payload) {
    var _a = serializer(_embedScriptByInstanceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_embedScriptResponse, {}).fromJSON;
    function __embedScriptByInstanceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
            method: 'POST',
            methodFqn: 'com.wixpress.market.aim.api.EmbeddedScriptsService.EmbedScriptByInstanceId',
            url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
                protoPath: '/v1/scripts/{instanceId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __embedScriptByInstanceId.fromReq = fromReq;
    __embedScriptByInstanceId.__isAmbassador = true;
    return __embedScriptByInstanceId;
}
/** Retrieves this app's existing embedded script parameters */
export function getEmbeddedScriptByInstanceId(payload) {
    var _a = serializer(_getEmbeddedScriptByInstanceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEmbeddedScriptResponse, {}).fromJSON;
    function __getEmbeddedScriptByInstanceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.EmbeddedScriptsService.GetEmbeddedScriptByInstanceId',
            url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
                protoPath: '/v1/scripts/{instanceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEmbeddedScriptByInstanceId.fromReq = fromReq;
    __getEmbeddedScriptByInstanceId.__isAmbassador = true;
    return __getEmbeddedScriptByInstanceId;
}
//# sourceMappingURL=http.impl.js.map